<script>
import { BreadcrumbItem } from 'element-ui';
const BreadcrumbItemWrapper = BreadcrumbItem;
BreadcrumbItemWrapper.name = 'JskBreadcrumbItem';
export default BreadcrumbItemWrapper;
</script>
